"use strict";Object.defineProperty(exports, "__esModule", {value: true});


var _XXF5DFSGcjs = require('./XXF5DFSG.cjs');


var _STJK5WUWcjs = require('./STJK5WUW.cjs');


var _KEDCOTT4cjs = require('./KEDCOTT4.cjs');


var _6E4BBKC4cjs = require('./6E4BBKC4.cjs');


var _FH6HQ5JNcjs = require('./FH6HQ5JN.cjs');




var _PTOCUU2Dcjs = require('./PTOCUU2D.cjs');





var _3BSDKDKDcjs = require('./3BSDKDKD.cjs');

// src/menu/menu-list.tsx
var _misc = require('@ariakit/core/utils/misc');
var _react = require('react');
var _jsxruntime = require('react/jsx-runtime');
var TagName = "div";
function useAriaLabelledBy({ store, ...props }) {
  const [id, setId] = _react.useState.call(void 0, void 0);
  const label = props["aria-label"];
  const disclosureElement = _FH6HQ5JNcjs.useStoreState.call(void 0, store, "disclosureElement");
  const contentElement = _FH6HQ5JNcjs.useStoreState.call(void 0, store, "contentElement");
  _react.useEffect.call(void 0, () => {
    const disclosure = disclosureElement;
    if (!disclosure) return;
    const menu = contentElement;
    if (!menu) return;
    const menuLabel = label || menu.hasAttribute("aria-label");
    if (menuLabel) {
      setId(void 0);
    } else if (disclosure.id) {
      setId(disclosure.id);
    }
  }, [label, disclosureElement, contentElement]);
  return id;
}
var useMenuList = _PTOCUU2Dcjs.createHook.call(void 0, 
  function useMenuList2({ store, alwaysVisible, composite, ...props }) {
    const context = _XXF5DFSGcjs.useMenuProviderContext.call(void 0, );
    store = store || context;
    _misc.invariant.call(void 0, 
      store,
      process.env.NODE_ENV !== "production" && "MenuList must receive a `store` prop or be wrapped in a MenuProvider component."
    );
    const parentMenu = store.parent;
    const parentMenubar = store.menubar;
    const hasParentMenu = !!parentMenu;
    const id = _3BSDKDKDcjs.useId.call(void 0, props.id);
    const onKeyDownProp = props.onKeyDown;
    const dir = _FH6HQ5JNcjs.useStoreState.call(void 0, 
      store,
      (state) => state.placement.split("-")[0]
    );
    const orientation = _FH6HQ5JNcjs.useStoreState.call(void 0, 
      store,
      (state) => state.orientation === "both" ? void 0 : state.orientation
    );
    const isHorizontal = orientation !== "vertical";
    const isMenubarHorizontal = _FH6HQ5JNcjs.useStoreState.call(void 0, 
      parentMenubar,
      (state) => !!state && state.orientation !== "vertical"
    );
    const onKeyDown = _3BSDKDKDcjs.useEvent.call(void 0, (event) => {
      onKeyDownProp == null ? void 0 : onKeyDownProp(event);
      if (event.defaultPrevented) return;
      if (hasParentMenu || parentMenubar && !isHorizontal) {
        const hideMap = {
          ArrowRight: () => dir === "left" && !isHorizontal,
          ArrowLeft: () => dir === "right" && !isHorizontal,
          ArrowUp: () => dir === "bottom" && isHorizontal,
          ArrowDown: () => dir === "top" && isHorizontal
        };
        const action = hideMap[event.key];
        if (action == null ? void 0 : action()) {
          event.stopPropagation();
          event.preventDefault();
          return store == null ? void 0 : store.hide();
        }
      }
      if (parentMenubar) {
        const keyMap = {
          ArrowRight: () => {
            if (!isMenubarHorizontal) return;
            return parentMenubar.next();
          },
          ArrowLeft: () => {
            if (!isMenubarHorizontal) return;
            return parentMenubar.previous();
          },
          ArrowDown: () => {
            if (isMenubarHorizontal) return;
            return parentMenubar.next();
          },
          ArrowUp: () => {
            if (isMenubarHorizontal) return;
            return parentMenubar.previous();
          }
        };
        const action = keyMap[event.key];
        const id2 = action == null ? void 0 : action();
        if (id2 !== void 0) {
          event.stopPropagation();
          event.preventDefault();
          parentMenubar.move(id2);
        }
      }
    });
    props = _3BSDKDKDcjs.useWrapElement.call(void 0, 
      props,
      (element) => /* @__PURE__ */ _jsxruntime.jsx.call(void 0, _XXF5DFSGcjs.MenuScopedContextProvider, { value: store, children: element }),
      [store]
    );
    const ariaLabelledBy = useAriaLabelledBy({ store, ...props });
    const mounted = _FH6HQ5JNcjs.useStoreState.call(void 0, store, "mounted");
    const hidden = _KEDCOTT4cjs.isHidden.call(void 0, mounted, props.hidden, alwaysVisible);
    const style = hidden ? { ...props.style, display: "none" } : props.style;
    props = {
      "aria-labelledby": ariaLabelledBy,
      hidden,
      ...props,
      id,
      ref: _3BSDKDKDcjs.useMergeRefs.call(void 0, id ? store.setContentElement : null, props.ref),
      style,
      onKeyDown
    };
    const hasCombobox = !!store.combobox;
    composite = composite != null ? composite : !hasCombobox;
    if (composite) {
      props = {
        role: "menu",
        "aria-orientation": orientation,
        ...props
      };
    }
    props = _6E4BBKC4cjs.useComposite.call(void 0, { store, composite, ...props });
    props = _STJK5WUWcjs.useCompositeTypeahead.call(void 0, { store, typeahead: !hasCombobox, ...props });
    return props;
  }
);
var MenuList = _PTOCUU2Dcjs.forwardRef.call(void 0, function MenuList2(props) {
  const htmlProps = useMenuList(props);
  return _PTOCUU2Dcjs.createElement.call(void 0, TagName, htmlProps);
});




exports.useMenuList = useMenuList; exports.MenuList = MenuList;
